// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"da6fbf9d","721":"d72d73c5"}[chunkId] + ".chunk.js";
};